import axios from 'axios'

export const state = {
}

export const getters = {
}

export const mutations = {
}

export const actions = {
  resolveCreditNotes({ commit }, { params = {} }) {
    return axios.get(`/credit-notes/search`, { params })
  },
  resolveCreditNote({ commit }, id) {
    return axios.get(`/credit-notes/${id}`)
  },
  createCreditNote({ commit }, data) {
    return axios.post('/credit-notes', data)
  },
  updateCreditNote({ commit }, data) {
    return axios.put(`/credit-notes/${data.id}`, data)
  },
  changeCreditNoteStatus({ commit }, params) {
    const payload = {}
    const creditNoteId = params.id
    payload.status = params.status
    payload.is_check = params.is_check
    return axios.put(`/credit-notes/${creditNoteId}/change-status`, payload)
  },
  deleteCreditNote({ commit }, id) {
    return axios.delete(`/credit-notes/${id}`)
  },
}
